import request from '@/utils/requestThingsBoard'

// get关系 asset
export function getTenantRelation (type) {
  return request({
    url: '/relations/all?typeGroup=' + type,
    method: 'get'
  })
}

// get关系 AdditionalInfo
export function getTenantRelationEnergy (type) {
  return request({
    url: '/relations/byType?type=' + type,
    method: 'get'
  })
}

// get关系 AdditionalInfo 区分tenant
export function getTenantRelationInfo (type, fromId) {
  return request({
    url: '/relations/byTypeAndFromId?type=' + type + '&fromId=' + fromId,
    method: 'get'
  })
}

// set关系
export function saveRelation (parentId, id, params, info) {
  const data = {
    type: params,
    typeGroup: 'COMMON',
    from: {
      entityType: params,
      id: parentId
    },
    to: {
      entityType: params,
      id: id
    }
  }
  if (info) {
    data.additionalInfo = info.data
    // data.type = info.type
    data.from.entityType = info.fromType
    data.to.entityType = info.toType
  }
  return request({
    url: '/relation',
    method: 'post',
    data: data
  })
}

export function deleteRelation (from, to, type) {
  const url = `/relation?fromId=${from.id}&fromType=${from.entityType}&toId=${to.id}&toType=${to.entityType}&relationType=${type}`
  return request({
    url: url,
    method: 'delete'
  })
}

// get energy list
export function getEnergyList () {
  return request({
    url: '/table/energy/get',
    method: 'get'
  })
}
// p 下的能源
export function getEnergyPList (pId) {
  return request({
    url: '/table/project/energy/' + pId,
    method: 'get'
  })
}

// add energy
export function addEnergy (params) {
  return request({
    url: '/table/energy/add',
    method: 'post',
    data: params
  })
}

// delete energy
export function delEnergy (id) {
  return request({
    url: '/table/energy/del?id=' + id,
    method: 'delete'
  })
}

// get告警 两种方法
// 根据tenantID获取
export function getAlarmList (params) {
  if (params) {
    return request({
      url: '/noAuthAlarm/alarmJson?secret=' + params,
      method: 'get'
    })
  } else {
    return request({
      url: '/alarmJson',
      method: 'get'
    })
  }
}

// 根据设备id获取
export function getAlarmJson (deviceId) {
  return request({
    url: '/alarmJson/get?deviceId=' + deviceId,
    method: 'get'
  })
}

// 保存告警设置
export function saveAlarm (params) {
  return request({
    url: '/alarmJson/save',
    method: 'post',
    data: params
  })
}

// 删除告警设置
export function deleteAlarm (alarmId) {
  return request({
    url: '/alarmJson/delete?id=' + alarmId,
    method: 'delete'
  })
}
